const utils = require("../../../components/utils/utils")(fox);

(function (fox, $, undefined) {
  "use strict";
  var _ = {
    payMethodOptions: [],
    newUser: false,
    buildPayMethodOptions: function (defOptions) {
      var availablePayMethods = [
        {
          alias: "select",
          title: "Select",
          value: 0,
          selected: true,
          hidden: false,
        },
        { alias: "check", title: "Check", value: 1 },
        { alias: "wire", title: "Wire", value: 2 },
        {
          alias: "payoneer",
          title: "Firstchoice Pay (Payoneer)",
          value: 3,
          disabled: 1,
        },
        { alias: "paxum", title: "Paxum", value: 4 },
        { alias: "ach", title: "ACH/Direct Deposit", value: 5 },
        { alias: "sepa", title: "SEPA", value: 6 },
        { alias: "paypal", title: "PayPal", value: 7, disabled: 1 },
        { alias: "usdt_eth", title: _.getTranslation("usdt_eth"), value: 8 },
        { alias: "usdt_trc", title: _.getTranslation("usdt_trc"), value: 9 },
        //{alias: 'skrill', title: _.getTranslation('skrill'), value: 10},
      ];

      var currentPayMethods = availablePayMethods.filter(function (item) {
        if (item.alias === "select") {
          return true;
        }

        return fox.include(defOptions, item.alias);
      });

      _.payMethodOptions = currentPayMethods;

      return currentPayMethods;
    },

    getPayMethodParams: function (id) {
      var data = {};

      fox.each(_.payMethodOptions, function (item) {
        if (item.value === id) {
          data = item;
        }
      });

      return data;
    },

    adressRegexp:
      /^(\d+[A-z# \/.,\d-]+)?([A-z# \/.,\d-]+\d+([A-z# \/.,-]+)?)?$/,
    nameRegexp: /^[A-z.,\d\-]{2,} [A-z. ,\d\-]*$/,
    paxumNameRegexp: /^[A-z. ,\d\-]*$/,

    toggleSubmitLoader: function (w, state) {
      var button = w.dom1("#save-payment-data") || w.dom1("#edit-payment-data");
      let action = !!state ? "add" : "remove";
      button.disabled = !!state;
      button.classList[action]("spin");
    },

    getTranslation: function (alias) {
      var translation = {
        fieldIsRequired: fox.i18n.getTranslation(
          "fieldIsRequired",
          "This field is required",
          "errors"
        ),
        incorrectPaymentInformation: fox.i18n.getTranslation(
          "incorrectPaymentInformation",
          "Incorrect payment information",
          "notifications"
        ),
        somethingWrong: fox.i18n.getTranslation(
          "somethingWrong",
          "Something wrong",
          "notifications"
        ),
        infoSuccessfullySaved: fox.i18n.getTranslation(
          "infoSuccessfullySaved",
          "Information has been successfully saved",
          "notifications"
        ),
        infoNotSaved: fox.i18n.getTranslation(
          "infoNotSaved",
          "Information has not been saved",
          "notifications"
        ),
        selectState: fox.i18n.getTranslation(
          "selectState",
          "Select your state"
        ),
        confirmRequest: fox.i18n.getTranslation(
          "confirmRequest",
          "To be able to send you the money and avoid issues please confirm that your payment method and payment details are correct on this page:",
          "notifications"
        ),
        confirm: fox.i18n.getTranslation("confirm", "confirm"),
        emptyCountry: fox.i18n.getTranslation(
          "34",
          "Please add your country.",
          "payout_details"
        ),
        selectCountry: fox.i18n.getTranslation(
          "selectCountry",
          "Please select a country from the drop-down list",
          "error"
        ),
        paxumPayableToBusinessPlaceholder: fox.i18n.getTranslation(
          "paxumPayableToBusinessPlaceholder",
          "Add Business Name"
        ),
        paxumPayableToIndividualPlaceholder: fox.i18n.getTranslation(
          "paxumPayableToIndividualPlaceholder",
          "Add your First and Last Name"
        ),
        payableToPlaceholder: fox.i18n.getTranslation(
          "payableToPlaceholder",
          "Add your First and Last Name or your Company name"
        ),
        payableToLabelValue: fox.i18n.getTranslation(
          "payableToLabelValue",
          "Pay to"
        ),
        paxumPayableToLabelValue: fox.i18n.getTranslation(
          "paxumPayableToLabelValue",
          "Pay to"
        ),
        paxumPayableToBusinessTooltip: fox.i18n.getTranslation(
          "paxumPayableToBusinessTooltip",
          "Your company's name associated with your Paxum account."
        ),
        paxumPayableToIndividualTooltip: fox.i18n.getTranslation(
          "paxumPayableToIndividualTooltip",
          "The first and last name associated with your Paxum account."
        ),
        payableToTooltip: fox.i18n.getTranslation(
          "payableToTooltip",
          "Please enter the First and Last Name of the person who will receive the payment and cash the checks OR the name of your company if you will cash checks as a company."
        ),
        paxumPayableToValidation: fox.i18n.getTranslation(
          "paxumPayableToValidation",
          "Please use latin letters only - no special symbols."
        ),
        payableToValidation: fox.i18n.getTranslation(
          "payableToValidation",
          "Please use latin letters only - no special symbols. Add both the First and Last name or full title of your company."
        ),
        payableToValidationSkrill: fox.i18n.getTranslation(
          "payableToValidationSkrill",
          "Please use latin letters only - no special symbols. Add both the First and Last name"
        ),
        paxumAccountNoLabelValue: fox.i18n.getTranslation(
          "paxumAccountNoLabelValue",
          "Business Registration Number"
        ),
        accountNoLabelValue: fox.i18n.getTranslation(
          "accountNoLabelValue",
          "Account number"
        ),
        paxumAccountNoTooltip: fox.i18n.getTranslation(
          "paxumAccountNoTooltip",
          "Your company's business registration number associated with your Paxum account."
        ),
        accountNoTooltip: fox.i18n.getTranslation(
          "accountNoTooltip",
          "The Account number is your unique digital identifier in your bank."
        ),
        paxumAccountNoValidation: fox.i18n.getTranslation(
          "paxumAccountNoValidation",
          "Please enter a valid registration number. Check to make sure there are no spaces or letters."
        ),
        accountNoValidation: fox.i18n.getTranslation(
          "accountNoValidation",
          "Please enter a valid account number. Check to make sure there are no spaces or letters."
        ),
        paxumAccountNoPlaceholder: fox.i18n.getTranslation(
          "paxumAccountNoPlaceholder",
          "Add Business Registration Number"
        ),
        accountNoPlaceholder: fox.i18n.getTranslation(
          "accountNoPlaceholder",
          "Add your Account number"
        ),
        birthDate: fox.i18n.getTranslation("birthDate", "Date of birth"),
        usdt_eth: fox.i18n.getTranslation(
          "usdtEthPayment",
          "USDT Ethereum/ERC20 network"
        ),
        usdtWalletPlaceholder: fox.i18n.getTranslation(
          "usdtWalletPlaceholder",
          "Enter your wallet address to receive USDT"
        ),
        usdtEthWalletTooltip: fox.i18n.getTranslation(
          "usdtEthWalletTooltip",
          "Wallet address is the address of your TRC wallet in Tron network. Address can contain letters and numbers. Max length of wallet address is 42 symbols."
        ),
        usdt_trc: fox.i18n.getTranslation(
          "usdtTrcPayment",
          "USDT Tron/TRC20 network"
        ),
        usdtTrcWalletTooltip: fox.i18n.getTranslation(
          "usdtTrcWalletTooltip",
          "Wallet address is the address of your USDT-TRC20 wallet address in Tron/TRC20 network. Address can contain letters and numbers. Max length of wallet address is 42 symbols."
        ),
        usdtTrcDesc: fox.i18n.getTranslation(
          "usdtTrcDesc",
          "Payments appear on your wallet within 1 hour."
        ),
        skrill: fox.i18n.getTranslation("skrillPayment", "Skrill"),
        skrillDesc: fox.i18n.getTranslation(
          "skrillDesc",
          "Payments are done in EURO currency only. Delivery time can vary from a few minutes to up to 2 business days."
        ),
        payableToTooltipSkrill: fox.i18n.getTranslation(
          "payableToTooltipSkrill",
          "The first and last name associated with your Skrill account."
        ),
        skrillPayToPlaceholder: fox.i18n.getTranslation(
          "skrillPayToPlaceholder",
          "Add your First and Last Name"
        ),
        checkDesc: fox.i18n.getTranslation(
          "checkDesc",
          "Checks are delivered within 2-4 weeks."
        ),
        wireDesc: fox.i18n.getTranslation(
          "wireDesc",
          "Payments appear on your account within 3-5 business days."
        ),
        paxumDesc: fox.i18n.getTranslation(
          "paxumDesc",
          "Payments appear on your account within 5-15 min."
        ),
        achDesc: fox.i18n.getTranslation(
          "achDesc",
          "Payments appear on your account within 24 hours."
        ),
        sepaDesc: fox.i18n.getTranslation(
          "sepaDesc",
          "Payments appear on your account within 2-3 business days."
        ),
        usdtTrcDesc: fox.i18n.getTranslation(
          "usdtTrcDesc",
          "Payments appear on your wallet within 1 hour."
        ),
        usdtEthDesc: fox.i18n.getTranslation(
          "usdtEthDesc",
          "Payments appear on your wallet within 1 hour."
        ),
        skrillDesc: fox.i18n.getTranslation(
          "skrillDesc",
          "Payments are done in EURO currency only. Delivery time can vary from a few minutes to up to 2 business days."
        ),
        individual: fox.i18n.getTranslation("individual", "Individual"),
        sole: fox.i18n.getTranslation(
          "soleProprietorship",
          "Sole proprietorship"
        ),
        partnership: fox.i18n.getTranslation("partnership", "Partnership"),
        llc: fox.i18n.getTranslation(
          "limitedLiabilityCompany",
          "Limited liability company (LLC)"
        ),
        corporation: fox.i18n.getTranslation(
          "corporation",
          "Corporation (Inc., Ltd., Corp.)"
        ),
        business: fox.i18n.getTranslation("business", "Business"),
        select: fox.i18n.getTranslation(
          "select",
          "Please choose your type of business"
        ),
        selectPaxum:
          ("selectPaxum", "Please choose type of your Paxum account"),
        nameDoesntMatch: fox.i18n.getTranslation(
          "nameDoesntMatch",
          'The name doesn\'t match the account owner. Please make sure to enter your First+Last name in the "FN LN" format, for e.g.: John Doe'
        ),
        wrongPostalCode: fox.i18n.getTranslation(
          "74",
          "Please enter postal code in the following format:" +
            '<span class="zip-format"></span>' +
            "<ul>Where:" +
            "<li>A = letter</li>" +
            "<li>N = number</li>" +
            "<li>? = letter or number</li>" +
            "<li>CC = ISO 3166-1 alpha-2 country code</li>" +
            "</ul>",
          "payout_details"
        ),
        verifyFirst: fox.i18n.getTranslation(
          "verifyFirst",
          "Account verification is required for this payout method. To verify your account, proceed"
        ),
        here: fox.i18n.getTranslation("here", "here"),
        orderVerifyFail: fox.i18n.getTranslation(
          "orderVerifyFail",
          "Order amount lower then minimum payout sum"
        ),
        emptyCountryOfBirth: fox.i18n.getTranslation(
          "pleaseAddCountryOfBirth",
          "Please add your сountry of birth."
        ),
        emptyCity: fox.i18n.getTranslation(
          "pleaseAddCity",
          "Please add your сity."
        ),
        emptyCityOfBirth: fox.i18n.getTranslation(
          "pleaseAddCityOfBirth",
          "Please add your сity of birth."
        ),
        emptyStreet: fox.i18n.getTranslation(
          "pleaseAddStreet",
          "Please add your street."
        ),
        emptyBuildingNo: fox.i18n.getTranslation(
          "pleaseAddBuildingNo",
          "Please add your building No."
        ),
        emptyPostCode: fox.i18n.getTranslation(
          "pleaseAddPostCode",
          "Please add your post code."
        ),
        enterValidEmail: fox.i18n.getTranslation(
          "enterValidEmail",
          "Please enter a valid email address."
        ),
        confirmOwnerPaxumAccount: fox.i18n.getTranslation(
          "confirmOwnerPaxumAccount",
          "Please confirm that you are the owner of the Paxum account by checking the box."
        ),
        enterValidEmailConfirmOwnerPaxumAccount: fox.i18n.getTranslation(
          "enterValidEmailConfirmOwnerPaxumAccount",
          "Please enter a valid email address and confirm that you are the owner of the Paxum account by checking the box."
        ),
      };

      return translation[alias] || "";
    },

    currentDate: new Date(),
  };

  const mapOrder = {
    4: {
      minPayout: 1,
      legalType: 2,
      payableTo: 3,
      firstName: 3,
      lastName: 3,
      accountNo: 4,
      birthdate: 4,
      paymentEmail: 5,
      country: 6,
      ownershipDocument: 7,
      dac7Form: 8,
    },
  };

  const payMethodsDesc = [
    { alias: "select", value: 0 },
    { alias: "checkDesc", value: 1 },
    { alias: "wireDesc", value: 2 },
    { alias: "paxumDesc", value: 4 },
    { alias: "achDesc", value: 5 },
    { alias: "sepaDesc", value: 6 },
    { alias: "usdtTrcDesc", value: 9 },
    { alias: "usdtEthDesc", value: 8 },
    //{alias: 'skrillDesc', value: 10},
  ];

  require("security-payment-details")(fox);

  fox.registerWidget(
    "Account_PaymentDetails",
    {
      configure: function () {
        this._cacheCountry = false;
        this._methodMinPayouts = [
          0, 100, 1250, 50, 50, 100, 290, 50, 2000, 500, 50,
        ];
        this.registerOptions("", {
          autoRender: true,
          // manualRender: true,
          template: "payout_details",
          "embed.container": "#payout-details",
          clientId: null,
          validatorRules: {
            accountNo: [
              {
                validator: "regexp",
                options: { regexp: /^([0-9]*[1-9][0-9]*)$/ },
              },
            ],
            accountType: [{ validator: "mandatory" }],
            bankAddress: [
              { validator: "mandatory" },
              { validator: "regexp", options: { regexp: _.adressRegexp } },
            ],
            bankCode: [
              {
                validator: "regexp",
                options: { regexp: /^[A-z]{6}(?:[A-z\d]{2}|[A-z\d]{5})$/ },
              },
            ],
            abaCode: [{ validator: "regexp", options: { regexp: /^\d{9}$/ } }],
            bankName: [
              {
                validator: "regexp",
                options: { regexp: /^[A-z \d.,\\'-]{3,}$/ },
              },
            ],
            beneficiary: [
              { validator: "regexp", options: { regexp: _.nameRegexp } },
            ],
            beneficiaryAddress: [
              { validator: "mandatory" },
              { validator: "regexp", options: { regexp: _.adressRegexp } },
            ],
            iban: [
              {
                validator: "regexp",
                options: { regexp: /^[A-z]{2}[A-z\d]{2,32}$/ },
              },
            ],
            minPayout: [{ validator: "range", options: { min: 50 } }],
            payableTo: [
              { validator: "regexp", options: { regexp: _.nameRegexp } },
            ],
            paymentEmail: [{ validator: "regexp", options: { type: "email" } }],
            zipCode: [{ validator: "postalcode" }],
            city: [{ validator: "mandatory" }],
            address: [
              { validator: "mandatory" },
              { validator: "regexp", options: { regexp: _.adressRegexp } },
            ],
            state: [{ validator: "mandatory" }],
            institutionNumber: [
              { validator: "regexp", options: { regexp: /^\d{3}$/ } },
            ],
            transitNumber: [
              { validator: "regexp", options: { regexp: /^\d{5}$/ } },
            ],
            country: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyCountry"),
              },
            ],
            firstName: [
              { validator: "mandatory" },
              { validator: "length", options: { min: 2 } },
            ],
            lastName: [
              { validator: "mandatory" },
              { validator: "length", options: { min: 2 } },
            ],
            birthDate: [
              {
                validator: "mandatory",
                message: _.getTranslation("selectBirthday"),
              },
            ],
            wallet: [
              {
                validator: "regexp",
                options: { regexp: /^[a-zA-Z0-9]{1,42}$/ },
              },
            ],
            businessName: [{ validator: "mandatory" }],
            firstNameDac7: [
              { validator: "mandatory" },
              { validator: "length", options: { min: 2 } },
            ],
            lastNameDac7: [
              { validator: "mandatory" },
              { validator: "length", options: { min: 2 } },
            ],
            birthdateDac7: [
              {
                validator: "mandatory",
                message: _.getTranslation("selectBirthday"),
              },
            ],
            addressCountry: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyCountry"),
              },
            ],
            addressCity: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyCity"),
              },
            ],
            addressStreet: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyStreet"),
              },
            ],
            addressBuilding: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyBuildingNo"),
              },
            ],
            zipCodeAddress: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyPostCode"),
              },
              { validator: "postalcode" },
            ],
            birthCountry: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyBirthCountry"),
              },
            ],
            birthCity: [
              {
                validator: "mandatory",
                message: _.getTranslation("emptyBirthCity"),
              },
            ],
          },
          widgets: {
            paymentDetailsFields: {
              widget: "Account_PaymentDetailsFields",
            },
            paymentFieldsValidation: {
              widget: "PaymentFieldsValidation",
            },
            savePaymentDataButton: {
              widget: "Widget",
              "embed.container": "#save-buttons",
              autoRender: false,
              handleDom: {
                savePaymentData: {
                  event: "click",
                  target: "#save-payment-data",
                  callback: "@parent:paymentDataSave",
                },
                editPaymentData: {
                  event: "click",
                  target: "#edit-payment-data",
                  callback: "@parent:paymentDataEdit",
                },
              },
              handleWom: {
                unlockButton: {
                  widget: "@parent #securityData",
                  event: "cancelPopup",
                  callback: () => {
                    _.toggleSubmitLoader(this, false);
                  },
                },
              },
            },
            securityData: {
              widget: "Security_Data",
            },
            paymentDataLoad: {
              widget: "Api",
              method: "model.profile.getPredefinedPaymentData",
              handleWom: {
                paymentDataLoadSuccess: {
                  event: "success",
                  widget: "@this",
                  callback: "@parent:paymentDataLoadSuccess",
                },
                paymentDataLoadFailure: {
                  event: ["error", "failure"],
                  widget: "@this",
                  callback: "@parent:paymentDataLoadFailure",
                },
              },
            },
            paymentForm: {
              widget: "Form",
              autoApply: true,
              formElements: {
                accountNo: { element: '[name="accountNo"]' },
                accountType: { element: '[name="accountType"]' },
                bankAddress: { element: '[name="bankAddress"]' },
                bankCode: { element: '[name="bankCode"]' },
                abaCode: { element: '[name="abaCode"]' },
                bankName: { element: '[name="bankName"]' },
                beneficiary: { element: '[name="beneficiary"]' },
                beneficiaryAddress: { element: '[name="beneficiaryAddress"]' },
                iban: { element: '[name="iban"]' },
                minPayout: { element: '[name="minPayout"]' },
                payableTo: { element: '[name="payableTo"]' },
                address: { element: '[name="address"]' },
                city: { element: '[name="city"]' },
                state: { element: '[name="state"]' },
                zipCode: { element: '[name="zipCode"]' },
                paymentEmail: { element: '[name="paymentEmail"]' },
                institutionNumber: { element: '[name="institutionNumber"]' },
                transitNumber: { element: '[name="transitNumber"]' },
                //legalType:{element: '[name="legalType"]'},
                firstName: { element: '[name="firstName"]' },
                lastName: { element: '[name="lastName"]' },
                wallet: { element: '[name="wallet"]' },
                tin: { element: '[name="tin"]' },
                vat: { element: '[name="vat"]' },
                ffirstNameDac7: { element: '[name="firstNameDac7"]' },
                middleName: { element: '[name="middleName"]' },
                lastNameDac7: { element: '[name="lastNameDac7"]' },
                birthdateDac7: { element: '[name="birthdateDac7"]' },
                addressCountry: { element: '[name="addressCountry"]' },
                addressCity: { element: '[name="addressCity"]' },
                addressStreet: { element: '[name="addressStreet"]' },
                addressBuilding: { element: '[name="addressBuilding"]' },
                zipCodeAddress: { element: '[name="zipCodeAddress"]' },
                birthCity: { element: '[name="birthCity"]' },
                // ownershipDocument: { element: '[name="ownershipDocument"]' },
                country: {
                  element: {
                    widget: "SitePage_Profile_Search_Country",
                    container: "#payment-country-search-input",
                    template: "sitepage_profile_searchbox",
                    dispatchEventIfFieldGetEmpty: true,
                    active: true,
                    emptyPlaceholder: "addCountryOfResidence",
                    "handleWom.changed": {
                      widget: "@this",
                      event: "changed",
                      callback: function (country) {
                        this.setDac7Data("addressCountry", country);
                      }.bind(this),
                    },
                  },
                },
                birthCountry: {
                  element: {
                    widget: "SitePage_Profile_Search_Country",
                    container: "#payment-country-of-birth-search-input",
                    template: "sitepage_profile_searchbox",
                    dispatchEventIfFieldGetEmpty: true,
                    active: true,
                    emptyPlaceholder: "addCountryOfBirth",
                  },
                },
                birthdate: {
                  element: {
                    widget: "CustomDatepicker",
                    container: ".birthday",
                    autoRender: true,
                    emptyPlaceholder: _.getTranslation("birthDate"),
                    autoPosition: true,
                    yearsLimitReverse: true,
                    yearsLimit: ["1940", _.currentDate.getFullYear() - 18],
                    dpOptions: {
                      yearRange: "1940:" + (_.currentDate.getFullYear() - 18),
                      minDate: "-80y",
                      maxDate: "-18y",
                      dateFormat: "mm/dd/yy",
                    },
                    highlightDate: (function () {
                      var date = new Date();
                      date.setFullYear(date.getFullYear() - 18);
                      return date;
                    })(),
                    "handleWom.selectDate": {
                      widget: "@this",
                      event: "selectDate",
                      callback: function (params, widget) {
                        this.prepareBirthdate(
                          "birthdateDac7",
                          widget.element[0].innerText,
                          "birthdate"
                        );
                      }.bind(this),
                    },
                  },
                },
                birthdateDac7: {
                  element: {
                    widget: "CustomDatepicker",
                    container: ".birthdateDac7",
                    autoRender: true,
                    emptyPlaceholder: _.getTranslation("birthDate"),
                    autoPosition: true,
                    yearsLimitReverse: true,
                    yearsLimit: ["1940", _.currentDate.getFullYear() - 18],
                    dpOptions: {
                      yearRange: "1940:" + (_.currentDate.getFullYear() - 18),
                      minDate: "-80y",
                      maxDate: "-18y",
                      dateFormat: "mm/dd/yy",
                    },
                    highlightDate: (function () {
                      var date = new Date();
                      date.setFullYear(date.getFullYear() - 18);
                      return date;
                    })(),
                    "handleWom.selectDate": {
                      widget: "@this",
                      event: "selectDate",
                      callback: function (params, widget) {
                        this.prepareBirthdate(
                          "birthdate",
                          widget.element[0].innerText,
                          "birthdateDac7"
                        );
                      }.bind(this),
                    },
                  },
                },
              },
            },
            paymentDataAssign: {
              widget: "Api",
              method: "model.profile.assignPaymentData",
            },
            paymentDataSave: {
              widget: "Api",
              method: "model.profile.savePaymentData",
            },
            nextPayoutCheck: {
              widget: "Api",
              method: "model.profile.getNextPayoutAmount",
              handleWom: {
                nextPayoutCheckSuccess: {
                  event: "success",
                  widget: "@this",
                  callback: "@parent:nextPayoutCheckSuccess",
                },
              },
            },
            payMethod: {
              widget: "Control_Select",
              "embed.container": "#pay-method",
              defaultPayMethods: [
                "check",
                "wire",
                "payoneer",
                "paxum",
                "ach",
                "sepa",
                "usdt_eth",
                "usdt_trc" /*'skrill'*/,
              ],
              "hooks.onStartRunning": function () {
                var payOptions = _.buildPayMethodOptions(
                  this.getOption("defaultPayMethods") || []
                )
                  .map(function (v) {
                    return v;
                  }, this)
                  .filter(function (v) {
                    return !v.hidden;
                  });

                this.setOption("select.options", payOptions);
              },
            },
            legalType: {
              widget: "Control_Select",
              "embed.container": "#legalType",
              select: {
                options: [
                  {
                    alias: "select",
                    title: _.getTranslation("select"),
                    value: 0,
                    selected: true,
                    hidden: true,
                  },
                  {
                    alias: "individual",
                    title: _.getTranslation("individual"),
                    value: "Individual",
                  },
                  {
                    alias: "sole",
                    title: _.getTranslation("sole"),
                    value: "Sole proprietorship",
                  },
                  {
                    alias: "partnership",
                    title: _.getTranslation("partnership"),
                    value: "Partnership",
                  },
                  {
                    alias: "llc",
                    title: _.getTranslation("llc"),
                    value: "LLC",
                  },
                  {
                    alias: "corporation",
                    title: _.getTranslation("corporation"),
                    value: "Corporation",
                  },
                ],
              },
              handleWom: {
                updateFields: {
                  event: "change",
                  widget: "@this",
                  callback: "@parent:updateFields",
                },
              },
            },
            legalTypePaxum: {
              widget: "Control_Select",
              "embed.container": "#legalTypePaxum",
              select: {
                options: [
                  {
                    alias: "select",
                    title: _.getTranslation("selectPaxum"),
                    value: 0,
                    selected: true,
                    hidden: true,
                  },
                  {
                    alias: "individual",
                    title: _.getTranslation("individual"),
                    value: "Individual",
                  },
                  {
                    alias: "business",
                    title: _.getTranslation("business"),
                    value: "Business",
                  },
                ],
              },
            },
          },
          handleWom: {
            formValueChange: {
              widget: "#paymentForm",
              event: "valueChange",
              callback: "_handleValueChange",
            },
            payMethodChange: {
              event: "change",
              widget: "#payMethod",
              callback: "_paymethodChange",
            },
            legalValueChange: {
              widget: "#legalType",
              event: "change",
              callback: "_handleLegalChange",
            },
            legalPaxumValueChange: {
              widget: "#legalTypePaxum",
              event: "change",
              callback: "_handleLegalChange",
            },
            onWrongPayInfo: {
              event: "notValidPayInfo",
              widget: "@this",
              callback: fox.bind(function (data) {
                this.notices.pushNotification({
                  noticeMessage:
                    _.getTranslation("incorrectPaymentInformation") +
                    " (" +
                    data.join(", ") +
                    ")",
                  noticeType: "error",
                  noticeTemplate: "new_notice",
                  noticeAlias: "incorrectPaymentInformation",
                  delayClose: 5000,
                  listenWidgetDeactivate: this,
                });
                _.toggleSubmitLoader(this, false);
              }, this),
            },
            paymentDataSaveSuccess: {
              event: "securityPaymentDataSaveSuccess",
              widget: "#securityData",
              callback: (...args) => {
                this.paymentDataLoad();
                this.paymentDataSaveSuccess(...args);
              },
            },
            paymentDataSaveFailure: {
              event: "paymentDataSaveFailure",
              widget: "#securityData",
              callback: (...args) => {
                switch (args[0].params.answer.code) {
                  case 6038:
                    if (args[0].params.answer.reason == "Wrong legalName") {
                      $(this.dom1('[data-row="firstName"]')).toggleClass(
                        "warning",
                        true
                      );
                      this.paymentDataNameFailure();
                    } else if (
                      args[0].params.answer.reason == "Not approved legal data"
                    ) {
                      this.paymentDataVerifyFailure();
                    }
                    break;
                  case 6039:
                    $(this.dom1('[data-row="lastName"]')).toggleClass(
                      "warning",
                      true
                    );
                    this.paymentDataNameFailure();
                    break;
                  case 6030:
                    this.paymentDataVerifyFailureStudio();
                    break;
                  case 6040:
                  case 4041:
                    if (args[0].params.answer.type == "6") {
                      this.paymentDataVerifyFailure();
                    } else if (args[0].params.answer.type == "4") {
                      this.paymentDataVerifyOrderFailure();
                    }
                    break;
                  default:
                    this.paymentDataSaveFailure();
                }
              },
            },
          },
          handleDom: {
            changeOwnershipDocument: {
              target: '[name="ownershipDocument"]',
              event: "change",
              callback: (elt) => {
                this.convertFileToBase64(elt);
              },
            },
            changePaxumConfirmed: {
              target: "#paxumConfirmed",
              event: "change",
              callback: () => {
                this._validateField("paymentEmail");
              },
            },
            download: {
              target: ".download",
              event: "click",
              callback: (el) => {
                this.downloadFile(el);
              },
            },
            remove: {
              target: ".remove",
              event: "click",
              callback: (el) => {
                this._bindData.ownershipDocument = "";
                this._bindData.ownershipDocumentData = "";
                let uploadEl = document.querySelector(
                  "[name=ownershipDocument]"
                );
                uploadEl.value = "";
                uploadEl.parentElement.classList.add("empty");
                uploadEl.parentElement.firstChild.textContent =
                  "Upload document";
              },
            },
            clearError: {
              target: "input",
              event: "focus",
              callback: (el) => {
                console.log("focus", el);
                let parent = el.closest(".property-item");
                if (parent.classList.contains("warning")) {
                  parent.classList.remove("warning");
                }
              },
            },
            savePaymentAndDac7: {
              event: "click",
              target: "#save-payment_dac7-data",
              callback: "paymentDataSave",
            },
            handleInputsBlur: {
              target: ".fields2send",
              event: "blur",
              callback: (el) => {
                el.value = el.value.trim();
              },
            },
          },
        });

        return this.callParent("configure", arguments);
      },

      init: function () {
        var paymentDataLoadMethod = this.getOption("paymentDataLoadMethod");
        if (paymentDataLoadMethod) {
          this.registerOptions("#paymentDataLoad", {
            method: paymentDataLoadMethod,
          });
        }
        var paymentDataSaveMethod = this.getOption("paymentDataSaveMethod");
        if (paymentDataSaveMethod) {
          this.registerOptions("#paymentDataSave", {
            method: paymentDataSaveMethod,
          });
        }

        this._bindData = {
          selectedMethod: "",
          paxumRegisterLinkState: "hide",
          wallet_tooltip: "",
          payableTo_tooltip: _.getTranslation("payableToTooltip"),
          payableTo_validation: _.getTranslation("payableToValidation"),
          payableTo_labelValue: _.getTranslation("payableToLabelValue"),
          accountNo_tooltip: _.getTranslation("accountNoTooltip"),
          accountNo_validation: _.getTranslation("accountNoValidation"),
          accountNo_labelValue: _.getTranslation("accountNoLabelValue"),
          ownershipDocument: "",
          ownershipDocumentData: "",
          tin_validation: "",
          dac7_type: "",
        };
        this.callParent("init", arguments);
        this.validator = new fox.Validator();
      },

      prepareEmbeddedWidgets: function () {
        this.bindTemplateVariables(this._bindData, [
          "selectedMethod",
          "paxumRegisterLinkState",
          "wallet_tooltip",
          "payableTo_tooltip",
          "payableTo_validation",
          "payableTo_labelValue",
          "accountNo_tooltip",
          "accountNo_validation",
          "accountNo_labelValue",
          "ownershipDocument",
          "ownershipDocumentData",
          "tin_validation",
          "dac7_type",
        ]);

        this.callParent("prepareEmbeddedWidgets", arguments);
      },

      running: function () {
        this.callParent("running", arguments);
        this.pm = this.wom1("#payMethod");
        this.legalTypeSelect = this.wom1("#legalType");
        this.legalTypePaxumSelect = this.wom1("#legalTypePaxum");
        this.getFormFieldsData = this.wom1("#paymentDetailsFields");
        this.fieldsValidation = this.wom1("#paymentFieldsValidation");
        this.paymentDataButton = this.wom1("#savePaymentDataButton");
        this.sc = this.wom1("#securityData");
        this.notices = this.getNotices();
        this.getFormFields = this.getFormFieldsData.getFormFields;
        this.pmAlias = this.getFormFieldsData.getPmAlias();
        this.countries = this.getFormFieldsData.getCountries();
        this.states = this.getFormFieldsData.getStates();
        this.addValidateRules();
        this.setSiteName();
      },

      deactivate: function () {
        this.dispatchEvent("deactivate");

        if (
          this.noticesForRemove !== undefined &&
          this.noticesForRemove.length > 0
        ) {
          this.noticesForRemove.forEach(function (alias) {
            this.notices.pullNotification(alias);
          }, this);

          this.noticesForRemove = [];
        }

        this.pm.value = 0;

        this.callParent("deactivate", arguments);
      },

      addedToDom: function () {
        $(this.element)
          .find(".gui-tooltip-link")
          .tooltip({
            position: {
              my: "left-20% bottom-15",
              at: "left top",
              collision: "flipfit",
              using: function (pos, feedb) {
                $(this)
                  .css(pos)
                  .addClass(feedb.vertical)
                  .addClass(feedb.horizontal);
              },
            },
            tooltipClass: "gui-tooltip-type-1",
            items: ".gui-tooltip-link",
            content: function () {
              var tool = $(this).find(".tt-content").html();
              return tool;
            },
            open: function () {
              this.openTooltip(arguments);
            }.bind(this),
            hide: { delay: 1000 },
          });

        $(this.element)
          .find(".gui-tooltip-error")
          .tooltip({
            position: {
              my: "right+20 bottom-15",
              at: "right top",
              collision: "flipfit",
              using: function (pos, feedb) {
                $(this)
                  .css(pos)
                  .addClass(feedb.vertical)
                  .addClass(feedb.horizontal);
              },
            },
            tooltipClass: "gui-tooltip-type-1 right-20 color-red",
            items: ".gui-tooltip-error",
            content: function () {
              var tool = $(this).find(".tt-content").html();
              return tool;
            },
            open: function () {
              this.openTooltip(arguments);
            }.bind(this),
            hide: { delay: 1000 },
          });
      },

      getNotices: function () {
        var notices = fox.wom
          .select("~#throughNotifications")
          .filter(function (item) {
            var w = item.wom1("#throughNotificationsContainer");
            return w.isActive();
          });

        var f = function () {
          return fox.wom
            .select("~#throughNotifications")
            .filter(function (item) {
              var w = item.wom1("#throughNotificationsContainer");
              return !fox.isEmpty(w.element);
            })[0];
        };

        if (notices.length === 1) {
          return notices[0];
        } else if (notices.length > 1) {
          if (this.isEmbedded()) {
            return f.call(this);
          } else {
            this.wait("addedToDom").then(
              function () {
                this.notices = f.call(this);
              }.bind(this)
            );

            return notices[0];
          }
        }
      },

      openTooltip: function (arg) {
        var e = arg[0];
        var ui = arg[1];
        var arrowLeft =
          $(e.srcElement).offset().left - ui.tooltip.offset().left;
        ui.tooltip.find(".tt-arrow").css("left", arrowLeft + 7 + "px");

        var tooltipLink = $("[aria-describedby]").eq(0);
        if (tooltipLink.offset().top > ui.tooltip.offset().top) {
          $(".gui-tooltip-type-1").addClass("bottom");
        }
        $(window).resize(function () {
          ui.tooltip.remove();
        });
      },

      setClient: function (clientId) {
        if (clientId && fox.isNumeric(parseInt(clientId))) {
          this.setOption("clientId", parseInt(clientId));
        } else {
          return false;
        }
        this.paymentDataLoad();
      },

      paymentDataLoad: function () {
        var clientId = this.getOption("clientId");

        if (clientId && fox.isNumeric(parseInt(clientId))) {
          this.wom1("#paymentDataLoad").send(
            {
              clientId: clientId,
            },
            false
          );
        }
      },

      paymentDataSave: function () {
        _.toggleSubmitLoader(this, true);

        var data = this.getPaymentData();
        if (!this.validate(data)) {
          return false;
        }

        var dataForSend = this.prepareData(data);

        if (this.startPaymentMethod != 0) {
          _.newUser = false;
          return this.sc.setData(dataForSend).then((id) => {
            if (this._bindData.ownershipDocumentData.length > 0) {
              return this.sc.setImageData(
                this._bindData.ownershipDocumentData,
                id
              );
            }
            return id;
          });
        } else {
          _.newUser = true;
          setTimeout(() => {
            return this.sc.setNew(dataForSend).then((id) => {
              if (this._bindData.ownershipDocumentData.length > 0) {
                return this.sc.setImageData(
                  this._bindData.ownershipDocumentData,
                  id
                );
              }
              return id;
            });
          }, 500);
        }
      },

      paymentDataEdit: function () {
        _.toggleSubmitLoader(this, true);
        this.valuesSets = 1;
        return this.sc.getData(this.valsId).then((res) => {
          if (!fox.isEmpty(res)) {
            res = JSON.parse(res);
            this.sc.getDocument(this.valsId).then((vals) => {
              this._bindData.ownershipDocumentData = vals;
            });
            this.renderButton(this.startPaymentMethod);
            fox.dom.selectFirst("#payout-details").classList.remove("editable");
            this.setValues(res);
            this.updateStartedDac7Vals(res);
          } else {
            _.toggleSubmitLoader(this, false);
          }
        });
      },

      prepareData: function (data) {
        var dataForSend = {
          clientId: data.clientId,
          paymentMethod: data.paymentMethod,
        };
        var country =
          this.rwom1("#paymentForm").getValue("country") ||
          this.rwom1("#paymentForm")._beforeBuildValues.country;
        var legalType =
          data.paymentMethod == 4
            ? this.legalTypePaxumSelect.value
            : this.legalTypeSelect.value;
        const fields = this.getFormFields(
          data.paymentMethod,
          country,
          legalType
        );

        fox.each(
          data,
          function (value, name) {
            if (
              fox.inArray(
                this.getFormFields(
                  this.pm.value,
                  this.rwom1("#paymentForm").getValue("country") ||
                    this.rwom1("#paymentForm")._beforeBuildValues.country,
                  legalType
                ),
                name
              )
            ) {
              dataForSend[name] = value;
            }
          },
          this
        );

        if ([2, 4, 6].includes(data.paymentMethod)) {
          if (legalType === "Individual") {
            dataForSend["birthdate"] = utils.dateFormat(
              "%Y-%m-%d",
              this.rwom1("#paymentForm #birthdate").selectedDate
            );
            delete dataForSend["firstNameDac7"];
            delete dataForSend["lastNameDac7"];
            delete dataForSend["birthdateDac7"];
            if (data.paymentMethod === 4) {
              dataForSend["legalType"] = legalType;
            }
          } else {
            delete dataForSend["businessName"];
          }

          if (data.paymentMethod === 4) {
            dataForSend["paxumConfirmed"] = $(
              this.dom1('[data-row="paxumConfirmed"]')
            ).find("#paxumConfirmed")[0].checked
              ? 1
              : 0;
          }

          if (fields.includes("dac7Form")) {
            dataForSend["zipCode"] = dataForSend["zipCodeAddress"];
            dataForSend["city"] = dataForSend["addressCity"];
          }
          delete dataForSend["zipCodeAddress"];
          delete dataForSend["addressCountry"];
          delete dataForSend["addressCity"];
        }

        if (
          fields.includes("ownershipDocument") &&
          this._bindData.ownershipDocumentData.length > 0
        ) {
          dataForSend["ownershipDocument"] = this._bindData.ownershipDocument;
        }
        if (data.legalType === "Individual") {
          if ([2, 5, 6].includes(data.paymentMethod)) {
            dataForSend["beneficiary"] = data.firstName + " " + data.lastName;
          }
          if (data.paymentMethod == 1) {
            dataForSend["payableTo"] = data.firstName + " " + data.lastName;
          }
        }

        if (![2, 4, 6].includes(data.paymentMethod)) {
          delete dataForSend["birthdate"];
        } else if (legalType !== "Individual") {
          delete dataForSend["birthdate"];
        }

        return dataForSend;
      },

      paymentDataLoadSuccess: function (res) {
        if (!this.isEmbedded()) {
          this.wait("addedToDom").then(
            function () {
              this.paymentDataLoadSuccess(res);
            }.bind(this)
          );
          return;
        }

        if (!res.answer.status || res.answer.response === false) {
          this.notices.pushNotification({
            noticeMessage:
              res.answer.reason || _.getTranslation("somethingWrong"),
            noticeType: "error",
            noticeTemplate: "new_notice",
            noticeAlias: "errorLoadPaymentData",
            delayClose: 3000,
            listenWidgetDeactivate: this,
          });

          return;
        }

        var vals = res.answer.response;
        this.startPaymentMethod = vals.paymentMethod || 0;
        this.startLegalType = vals.legalType || 0;
        this.valsId = vals.id;

        this.renderButton(this.startPaymentMethod);

        if (!this.sc.needAuth() || this.startPaymentMethod == 0) {
          fox.dom.selectFirst("#payout-details").classList.remove("editable");
          if (this.startPaymentMethod > 0) {
            this.sc.getData(this.valsId).then((vals) => {
              vals = JSON.parse(vals);
              if (!fox.isEmpty(vals)) {
                this.setValues(vals);
                this.updateStartedDac7Vals(vals);
              }
            });
            this.sc.getDocument(this.valsId).then((vals) => {
              this._bindData.ownershipDocumentData = vals;
            });
          }
        } else {
          if (!fox.isEmpty(vals)) {
            vals = fox.each(vals, function (value, el) {
              vals[el] = fox.trim(value);
            });
            this.setValues(vals);
            this.updateStartedDac7Vals(vals);
          } else {
            this.setValues({});
          }
        }
      },

      paymentDataLoadFailure: function (res) {
        console.log("payment data is not loaded");
      },

      setValues: function (vals) {
        vals.paymentMethod = vals.paymentMethod || 0;
        this.prepareBirthdate("birthdate", vals.birthdate);
        this.prepareBirthdate("birthdateDac7", vals.birthdate);
        delete vals.birthdate;
        this.rwom1("#paymentForm").setValues(vals);
        this.pm.setValue(vals.paymentMethod, true);
        this.switchFormFields();

        this._updateCountryOptions(vals.paymentMethod, "country", vals.country);
        this._updateCountryOptions(
          vals.paymentMethod,
          "birthCountry",
          vals.birthCountry
        );

        if (this.wom1("#paymentForm #state")) {
          this._updateStateOptions(vals.country);
        } else {
          this.waitEvent(
            this.rwom1("#paymentForm"),
            "formElementsCreated",
            fox.bind(function () {
              this._updateStateOptions(vals.country);
            }, this)
          );
        }
        this._bindData.selectedMethod = vals.paymentMethod;
        this._bindData.ownershipDocument = vals.ownershipDocument || "";
        this.legalType = vals.legalType || 0;

        var legalType =
          vals.paymentMethod != 4
            ? this.legalTypeSelect
            : this.legalTypePaxumSelect;
        legalType.setValue(this.legalType);
      },

      setDac7Data(field, value) {
        var node = $(this.dom1('[data-row="' + field + '"]'));
        node.find(".placeholder").text(value);

        if (field !== "birthdateDac7") {
          var form = this.rwom1("#paymentForm");
          form.setValue(field, value);
        }
      },

      prepareBirthdate: function (widgetName, value, parentWidgetName) {
        var parentW = null,
          w = this.rwom1("#paymentForm #" + widgetName);

        if (parentWidgetName !== undefined) {
          parentW = this.rwom1("#paymentForm #" + parentWidgetName);
        }

        if (!fox.isEmpty(value) && value.indexOf("*") === -1) {
          if (parentW !== null) {
            w._setSelectedDate(parentW.selectedDate);
          }
          w.setOption("initialDate", utils.dateFormat("%m/%d/%Y", value));
          w.render();

          this.setDac7Data(
            "birthdateDac7",
            utils.dateFormat("%d %b %Y", value)
          );
        }
      },

      paymentDataSaveSuccess: function (resp) {
        _.toggleSubmitLoader(this, false);

        if (!resp.params.answer.status) {
          this.notices.pushNotification({
            noticeMessage:
              resp.params.answer.reason || _.getTranslation("somethingWrong"),
            noticeType: "error",
            noticeTemplate: "new_notice",
            noticeAlias: "errorSavePaymentData",
            delayClose: 3000,
            listenWidgetDeactivate: this,
          });
          return;
        }

        // this notification will show if payment's button is active
        /*this.notices.pushNotification({
				noticeMessage: _.getTranslation('infoSuccessfullySaved'),
				noticeType: 'success',
				noticeTemplate: 'new_notice',
				noticeAlias: 'successSave',
				 delayClose: 3000, 
				listenWidgetDeactivate: this
			});*/

        if (!_.newUser) {
          fox.site.gotoPage("payment-details-confirm");
        }

        var clientId = this.getOption("clientId");
        this.rwom1("#nextPayoutCheck").send({ clientId: clientId });
      },

      paymentDataVerifyFailure: function () {
        _.toggleSubmitLoader(this, false);

        this.notices.pushNotification({
          noticeMessage:
            _.getTranslation("verifyFirst") +
            ' <a href="/profile">' +
            _.getTranslation("here") +
            "</a>.",
          noticeType: "error",
          noticeTemplate: "new_notice",
          noticeAlias: "errorverifyAccount",
          listenWidgetDeactivate: this,
        });
      },

      paymentDataVerifyOrderFailure: function () {
        _.toggleSubmitLoader(this, false);

        this.notices.pushNotification({
          noticeMessage: _.getTranslation("orderVerifyFail"),
          noticeType: "error",
          noticeTemplate: "new_notice",
          noticeAlias: "errorverifyAccount",
          listenWidgetDeactivate: this,
        });
      },

      paymentDataVerifyFailureStudio: function () {
        _.toggleSubmitLoader(this, false);

        this.notices.pushNotification({
          noticeMessage:
            _.getTranslation("verifyFirst") +
            ' <a href="/holder-details">' +
            _.getTranslation("here") +
            "</a>.",
          noticeType: "error",
          noticeTemplate: "new_notice",
          noticeAlias: "errorverifyAccount",
          listenWidgetDeactivate: this,
        });
      },
      paymentDataSaveFailure: function () {
        _.toggleSubmitLoader(this, false);

        this.notices.pushNotification({
          noticeMessage: _.getTranslation("infoNotSaved"),
          noticeType: "error",
          noticeTemplate: "new_notice",
          noticeAlias: "errorSave",
          delayClose: 3000,
          listenWidgetDeactivate: this,
        });
      },

      paymentDataNameFailure: function () {
        _.toggleSubmitLoader(this, false);

        this.notices.pushNotification({
          noticeMessage: _.getTranslation("nameDoesntMatch"),
          noticeType: "error",
          noticeTemplate: "new_notice",
          noticeAlias: "errorSave",
          delayClose: 3000,
          listenWidgetDeactivate: this,
        });
      },

      nextPayoutCheckSuccess: function (data) {
        if (
          data.answer.response <
          this.rwom1("#paymentForm").getValue("minPayout")
        ) {
          return false;
        }

        this.notices.pushNotification({
          noticeMessage:
            _.getTranslation("confirmRequest") +
            ' <a href="/payment-details-confirm">' +
            _.getTranslation("confirm") +
            "</a>.",
          noticeType: "attention",
          noticeTemplate: "new_notice",
          noticeAlias: "confirmRequest",
        });

        this.removeNoticesBeforeDeactivate("confirmRequest");
      },

      switchFormFields: function () {
        var paymethod = +this.pm.getValue(),
          country =
            this.rwom1("#paymentForm").getValue("country") ||
            this.rwom1("#paymentForm")._beforeBuildValues.country,
          legalType =
            paymethod == 4
              ? this.legalTypePaxumSelect.value
              : this.legalTypeSelect.value,
          fields = this.getFormFields(paymethod, country, legalType);

        if (fields.includes("legalType")) {
          this._validateField("legalType", "switch");
        }

        this.currentFields = fields;
        this.changePaymentDescription(paymethod);
        this._bindData.selectedMethod = paymethod;
        this.togglePaxumRegisterLink(paymethod === 4);
        this.toggleBindText(paymethod, legalType);
        this.toggleFieldClasses(paymethod);

        /* this horror shold be rework for different text in tooltips on same field */
        $(".payPalMethod")[0].style.display =
          paymethod === 7 ? "block" : "none";
        $(".notPayPalMethod")[0].style.display =
          paymethod === 7 ? "none" : "block";

        var methodOrderMap = mapOrder[paymethod];
        fox.each(
          this.dom("[data-row]"),
          function (node) {
            node.style.display =
              fields.indexOf(node.getAttribute("data-row")) === -1
                ? "none"
                : "block";
            if (methodOrderMap !== undefined) {
              node.style.order = methodOrderMap[node.getAttribute("data-row")];
            } else {
              node.style.order = 0;
            }
          },
          this
        );

        this.setMinPayoutHint(paymethod);
      },

      toggleFieldClasses: function (paymethod) {
        var birthdateDac7Node = $(this.dom1('[data-row="birthdateDac7"]'));
        paymethod === 4
          ? birthdateDac7Node.addClass("locked")
          : birthdateDac7Node.removeClass("locked");
      },

      toggleBindText: function (paymethod, legalType) {
        var nodePayableTo = $(this.dom('[data-row="payableTo"]')),
          nodeAccountNo = $(this.dom('[data-row="accountNo"]'));

        this._bindData.dac7_type = [undefined, "0", "Individual"].includes(
          legalType
        )
          ? "individual"
          : "business";

        switch (paymethod) {
          case 4:
            this._bindData.payableTo_labelValue = _.getTranslation(
              "payableToLabelValue"
            );
            this._bindData.payableTo_validation = _.getTranslation(
              "paxumPayableToValidation"
            );
            this._bindData.accountNo_labelValue = _.getTranslation(
              "paxumAccountNoLabelValue"
            );
            this._bindData.accountNo_tooltip = _.getTranslation(
              "paxumAccountNoTooltip"
            );
            this._bindData.accountNo_validation = _.getTranslation(
              "paxumAccountNoValidation"
            );
            this._bindData.payableTo_tooltip =
              this.legalType === "Business"
                ? _.getTranslation("paxumPayableToBusinessTooltip")
                : _.getTranslation("paxumPayableToIndividualTooltip");

            if (nodePayableTo !== undefined) {
              var placeholderText =
                this.legalType === "Business"
                  ? _.getTranslation("paxumPayableToBusinessPlaceholder")
                  : _.getTranslation("paxumPayableToIndividualPlaceholder");
              if (nodePayableTo.find(".placeholder")[0].nodeValue === null) {
                nodePayableTo.find(".placeholder").text(placeholderText);
              }
              var elmPayableTo = nodePayableTo.find("input");
              elmPayableTo.attr("placeholder", placeholderText);
            }

            if (nodeAccountNo !== undefined) {
              var placeholderText = _.getTranslation(
                "paxumAccountNoPlaceholder"
              );
              if (nodeAccountNo.find(".placeholder")[0].nodeValue === null) {
                nodeAccountNo.find(".placeholder").text(placeholderText);
              }
              var elmAccountNo = nodeAccountNo.find("input");
              elmAccountNo.attr("placeholder", placeholderText);
            }

            break;
          case 8:
            this._bindData.wallet_tooltip = _.getTranslation(
              "usdtEthWalletTooltip"
            );
            break;
          case 9:
            this._bindData.wallet_tooltip = _.getTranslation(
              "usdtTrcWalletTooltip"
            );
            break;
            // case 10:
            // 	this._bindData.payableTo_tooltip = _.getTranslation('payableToTooltipSkrill');
            // 	var placeholderText = _.getTranslation('paxumPayableToIndividualPlaceholder');
            // 	nodePayableTo.find('.placeholder').text(placeholderText);
            // 	this._bindData.payableTo_validation = _.getTranslation('payableToValidationSkrill');
            // 	var elmPayableTo = nodePayableTo.find('input');
            // 	elmPayableTo.attr('placeholder', placeholderText);

            break;
          default:
            this._bindData.payableTo_labelValue = _.getTranslation(
              "payableToLabelValue"
            );
            this._bindData.payableTo_tooltip =
              _.getTranslation("payableToTooltip");
            this._bindData.payableTo_validation = _.getTranslation(
              "payableToValidation"
            );
            this._bindData.accountNo_labelValue = _.getTranslation(
              "accountNoLabelValue"
            );
            this._bindData.accountNo_tooltip =
              _.getTranslation("accountNoTooltip");
            this._bindData.accountNo_validation = _.getTranslation(
              "accountNoValidation"
            );

            if (nodePayableTo !== undefined) {
              var placeholderText = _.getTranslation("payableToPlaceholder");
              if (nodePayableTo.find(".placeholder")[0].nodeValue === null) {
                nodePayableTo.find(".placeholder").text(placeholderText);
              }
              var elmPayableTo = nodePayableTo.find("input");
              elmPayableTo.attr("placeholder", placeholderText);
            }

            if (nodeAccountNo !== undefined) {
              var placeholderText = _.getTranslation("accountNoPlaceholder");
              if (nodeAccountNo.find(".placeholder")[0].nodeValue === null) {
                nodeAccountNo.find(".placeholder").text(placeholderText);
              }
              var elmAccountNo = nodeAccountNo.find("input");
              elmAccountNo.attr("placeholder", placeholderText);
            }
            break;
        }
      },

      getPaymentData: function () {
        var payData = this.rwom1("#paymentForm").collectData();
        payData.paymentMethod = +this.pm.getValue();
        payData.clientId = parseInt(this.getOption("clientId"));
        payData.legalType = this.legalType;
        if ([1, 4, 10].includes(payData.paymentMethod)) {
          payData.beneficiary = "";
        } else {
          payData.payableTo = "";
        }
        if (this.legalType === "Individual") {
          if ([2, 5, 6].includes(payData.paymentMethod)) {
            payData.beneficiary = payData.firstName + " " + payData.lastName;
          }
          if (payData.paymentMethod == 1) {
            payData.payableTo = payData.firstName + " " + payData.lastName;
          }
        }
        return payData;
      },

      validate: function (data) {
        var errorFields = [];
        if (!this.isActive()) {
          return false;
        }
        if (!data.paymentMethod) {
          errorFields.push("Payment method");
        }
        var vf = this.getFormFields(
          data.paymentMethod,
          data.country,
          data.legalType
        );

        for (var i = 0; i < vf.length; i++) {
          if (!this._validateField(vf[i], data[vf[i]])) {
            errorFields.push(
              $(this.dom1('[data-row="' + vf[i] + '"]'))
                .find(".label-value")
                .text()
            );
          }
        }

        if (errorFields.length) {
          this.dispatchEvent("notValidPayInfo", errorFields);
          return false;
        }
        return true;
      },

      getLabelValue: function (field) {
        var paymethod = +this.pm.getValue();

        if (
          paymethod === 4 &&
          this.rwom1("#paymentForm").getValue("legalType") === "Business"
        ) {
          return $(this.dom1('[data-row="' + field + '"]'))
            .find(".label-value-paxum")
            .text();
        } else {
          return $(this.dom1('[data-row="' + field + '"]'))
            .find(".label-value")
            .text();
        }
      },

      _validateField: function (alias, value) {
        var valid = true,
          field = $(this.dom1('[data-row="' + alias + '"]')),
          paymethod = +this.pm.getValue();

        if (["zipCode", "zipCodeAddress"].includes(alias)) {
          if (value.length) {
            var countryCode = this.getCountryCode();
            if (!countryCode) {
              field
                .find(".tt-body")
                .html(_.getTranslation("selectCountry").toString());
              valid = false;
            } else if (!this.validator.validate(alias, value, countryCode)) {
              field
                .find(".tt-body")
                .html(_.getTranslation("wrongPostalCode").toString());
              var format = this.validator
                .getFieldFirstMessage("zipCode")
                .slice(27, -1);
              field.find(".zip-format").text(format);
              valid = false;
            }
          } else {
            field
              .find(".tt-body")
              .html(_.getTranslation("fieldIsRequired").toString());
            valid = false;
          }
        } else if (["country", "birthCountry"].includes(alias)) {
          if (!this.validator.validate(alias, value)) {
            valid = false;
          } else if (!this.checkCountry(value, alias)) {
            field
              .find(".tt-body")
              .html(_.getTranslation("selectCountry").toString());
            valid = false;
          }
        } else if (["birthdate", "birthdateDac7"].includes(alias)) {
          var dataPickerWidget = this.rwom1("#paymentForm #" + alias);
          if (dataPickerWidget.selectedDate === null) {
            field
              .find(".tt-body")
              .html(_.getTranslation("selectBirthday").toString());
            valid = false;
          }
        } else if (
          alias === "payableTo" &&
          paymethod === 4 &&
          this.legalType === "Business"
        ) {
          if (value === "") {
            valid = false;
          } else {
            valid = _.paxumNameRegexp.test(value);
          }
        } else if (alias === 'beneficiary' && this.legalType !== 'Individual') {
          valid = value !== '' && _.paxumNameRegexp.test(value);
        } else if (!this.validator.validate(alias, value)) {
          valid = false;
        }

        if (alias === "ownershipDocument") {
          if (
            [
              "LLC",
              "Corporation",
              "Sole proprietorship",
              "Partnership",
              "Business",
            ].includes(this.legalType) &&
            this._bindData.ownershipDocument.length == 0
          ) {
            valid = false;
          }
        }

        if (alias === "legalType" || alias === "legalTypePaxum") {
          if (parseInt(value) == 0) {
            valid = false;
          }
        }

        if (alias === "tin") {
          var paymethod = +this.pm.getValue(),
            countryCode = this.getCountryCode(),
            legalType =
              paymethod == 4
                ? this.legalTypePaxumSelect.value
                : this.legalTypeSelect.value,
            businessType = ["0", "Individual"].includes(legalType)
              ? "individual"
              : "business",
            validData = this.fieldsValidation.tinValidate(
              value,
              countryCode,
              businessType
            );
          this._bindData.tin_validation = validData.message;
          valid = validData.result;
        }

        if (alias === "paymentEmail") {
          var fields = this.getFormFields(
              paymethod,
              this.rwom1("#paymentForm").getValue("country"),
              this.legalType
            ),
            paxumConfirmed =
              fields.indexOf("paxumConfirmed") != -1
                ? field.find("#paxumConfirmed")[0].checked
                : true,
            emailValue = this.rwom1("#paymentForm").getValue("paymentEmail"),
            emailValid = this.validator.validate("paymentEmail", emailValue),
            valid = paxumConfirmed && emailValid;

          if (paymethod == 4) {
            field.find(".gui-s-checkbox").toggleClass("error", !paxumConfirmed);
          }

          if (!valid) {
            var paymentEmailWrongText =
              !emailValid && !paxumConfirmed
                ? _.getTranslation("enterValidEmailConfirmOwnerPaxumAccount")
                : !emailValid
                ? _.getTranslation("enterValidEmail")
                : _.getTranslation("confirmOwnerPaxumAccount");
            field.find(".tt-body").html(paymentEmailWrongText.toString());
          }
        }

        if (alias === "legalType") {
          var legalType =
            paymethod == 4
              ? this.legalTypePaxumSelect.value
              : this.legalTypeSelect.value;
          valid =
            value === "switch"
              ? true
              : ![undefined, "0", ""].includes(legalType);
        }

        field.toggleClass("warning", !valid);

        if (!valid) {
          if (!field.is("input")) {
            field.one("focus", function () {
              field.removeClass("warning");
            });
          } else {
            field.find("input").one("focus", function () {
              field.removeClass("warning");
            });
          }
        }
        return valid;
      },

      checkCountry: function (val, countryWidget) {
        return this.wom1("#paymentForm #" + countryWidget).inCollection(val);
      },

      getCurrentCountryName: function () {
        return this.wom1("#paymentForm").getValue("country");
      },

      getCountryCode: function () {
        //hack for find iso code, add method to SitePage_Profile_Search_Country
        var country = this.wom1("#paymentForm").getValue("country"),
          countryWidget = this.wom1("#paymentForm #country");

        if (countryWidget.formElement.value.trim() !== country) {
          return false;
        }
        var countryObj = countryWidget._collection.filter(function (e) {
          if (e.name === country) return e;
        });

        if (!countryObj || !countryObj.length) {
          return false;
        }
        return countryObj[0].id;
      },

      addValidateRules: function () {
        this.validator.setRules(this.options.validatorRules);
      },

      updateStartedDac7Vals: function (vals) {
        $(this.dom1('[data-row="paxumConfirmed"]')).find(
          "#paxumConfirmed"
        )[0].checked = vals.paxumConfirmed == 1;

        this.setDac7Data(
          "businessName",
          vals.paymentMethod === 4
            ? vals.payableTo
            : [2, 6].includes(vals.paymentMethod)
            ? vals.beneficiary
            : ""
        );

        this.setDac7Data("tin", vals.tin);
        this.setDac7Data("vat", vals.vat);
        this.setDac7Data("addressCity", vals.city);
        this.setDac7Data("addressStreet", vals.addressStreet);
        this.setDac7Data("addressBuilding", vals.addressBuilding);
        this.setDac7Data("zipCodeAddress", vals.zipCode);
        this.setDac7Data("birthCountry", vals.birthCountry);
        this.setDac7Data("birthCity", vals.birthCity);
      },

      setMinPayoutHint: function ($methodId) {
        var $min = this._methodMinPayouts[$methodId],
          $method = _.getPayMethodParams($methodId).title;
        // $method = $method.replace(/\s+\(.*\)/, '');

        //change min in validator
        this.validator._rules.minPayout[0].options = { min: $min };
        this.validator._rulesChanged = true;
        var node = $(this.dom('[data-row="minPayout"]')),
          node2 = $(this.dom('[data-row="paymentEmail"]')),
          elm = node.find("input");

        //node.find('.methodName').text($method);
        node2.find(".methodName").text($method);
        node.find(".min").text($min);

        if (!elm.val()) {
          node.find(".placeholder").text($min);
          elm.attr("placeholder", $min);
        }
      },

      setSiteName: function () {
        var site = window.location.hostname;

        site = site === "modelcentro.com" ? "ModelCentro" : "CentroProfits";
        this.setTemplateOptions("siteName", site);
      },
      _updateCountryOptions: function (pm, field, country) {
        pm = this.pmAlias[pm];
        var val = country || this.rwom1("#paymentForm").getValue(field),
          countries = this.countries[pm];
        if (pm && countries && field !== "birthCountry") {
          this.rwom1("#paymentForm #" + field).includeCollection(countries);
          if (val && countries.indexOf(val) !== -1) {
            this.rwom1("#paymentForm").setValue(field, val);
          } else {
            this._cacheCountry = val;
            if (countries.length === 1) {
              this.rwom1("#paymentForm").setValue(field, countries[0]);
            } else {
              this.rwom1("#paymentForm").setValue(field, "");
            }
          }
        } else {
          this.rwom1("#paymentForm #" + field).restoreCollection();
          if (val) {
            this.rwom1("#paymentForm").setValue(field, val);
          } else if (this._cacheCountry) {
            this.rwom1("#paymentForm").setValue(field, this._cacheCountry);
            this._cacheCountry = false;
          }
        }

        return this;
      },

      _updateStateOptions: function ($country) {
        if (!this.states[$country] || !this.wom1("#paymentForm #state")) {
          return;
        }
        var select = this.rwom1("#paymentForm #state").formElement,
          options = this.states[$country],
          option = document.createElement("option"),
          form = this.rwom1("#paymentForm");

        select.options.length = 0;
        //create default option
        option.innerText = _.getTranslation("selectState");
        option.value = "";
        option.style.display = "none";
        select.appendChild(option);

        fox.each(
          options,
          function (opt) {
            var option = document.createElement("option");
            option.innerText = opt.l;
            option.value = opt.v;
            select.appendChild(option);
          },
          this
        );
        var val =
          form._getValue("state") || form._beforeBuildValues.state || "";
        form.setValue("state", val);

        this.setDac7Data("addressCountry", val);
      },

      _paymethodChange: function (val) {
        if (this.isSetPaymentOption()) {
          this.hideErrorPaymentMethodNotice();
        } else {
          this.showErrorPaymentMethodNotice();
        }
        this.switchFormFields();
        this._updateCountryOptions(val, "country");
      },

      _handleLegalChange: function (value) {
        this._validateField("legalType", value);
        this.updateFields();
      },

      _handleValueChange: function (params) {
        if (params.alias === "firstName") {
          this.setDac7Data("firstNameDac7", params.value);
        }

        if (params.alias === "lastName") {
          this.setDac7Data("lastNameDac7", params.value);
        }

        if (["beneficiary", "payableTo"].includes(params.alias)) {
          this.setDac7Data("businessName", params.value);
        }

        // if (params.alias === 'zipCode') {
        // 	this.setDac7Data('zipCodeAddress', params.value);
        // }

        // if (params.alias === 'zipCodeAddress') {
        // 	var form = this.rwom1('#paymentForm');
        // 	if (form.getValue('zipCode') !== params.value) {
        // 	  form.setValue('zipCode', params.value);
        // 	}
        // }

        // if (params.alias === 'city') {
        // 	this.setDac7Data('addressCity', params.value);
        // }

        // if (params.alias === 'addressCity') {
        // 	var form = this.rwom1('#paymentForm');
        // 	if (form.getValue('city') !== params.value) {
        // 	  form.setValue('city', params.value);
        // 	}
        // }

        if (params.alias === "country") {
          this.switchFormFields();
          this._updateStateOptions(params.value);
        }

        if (!params.value) {
          return;
        }
        this._validateField(params.alias, params.value);
      },

      isSetPaymentOption: function () {
        var option = this.pm.getValue("payMethod");
        return !fox.isEmpty(option);
      },

      //refactor
      /*switchBankCode: function ($method, $country) {
			var bc = 'swift',
				node = $(this.dom1('[data-row="bankCode"]')),
				elm = node.find('input');
			if (!node || !elm) {
				return false;
			}

			var bankCodes = this.getFormFieldsData.getBankCodes($method, $country);
			//change regexp in validator
			this.validator._rules.bankCode[0].options = {'regexp': bankCodes.regexp};
			this.validator._rulesChanged = true;

			node.find('.label >:first').text(bankCodes.label);
			fox.each(node.find('.tt-body [data-bank-code]'), function(item) {
				$(item).toggle(item.getAttribute('data-bank-code') === bankCodes.type);
			});
			elm.attr('placeholder', bankCodes.placeholder);
			if (!elm.val()) {
				node.find('.placeholder').text(bankCodes.placeholder);
			}
		},*/

      payToggleView: function () {
        if (this.isActive()) {
          this.deactivate();
          $(this.element).hide();
        } else {
          this.activate();
          $(this.element).show();
        }
      },

      payShow: function () {
        if (!this.isActive()) {
          this.activate();
          $(this.element).show();
        }
      },

      payHide: function () {
        if (this.isActive()) {
          this.deactivate();
          $(this.element).hide();
        }
      },

      showErrorPaymentMethodNotice: function () {
        this.notices.pushNotification({
          noticeTemplate: "payment_method_notice",
          noticeType: "error",
          delayClose: false,
          noticeAlias: "paymentMethodNoSelected",
        });

        return this;
      },

      hideErrorPaymentMethodNotice: function () {
        this.notices.pullNotification("paymentMethodNoSelected");
        return this;
      },

      removeNoticesBeforeDeactivate: function (alias) {
        if (this.noticesForRemove === undefined) {
          this.noticesForRemove = [];
        }

        this.noticesForRemove.push(alias);
      },

      confirmPaymentData: function () {
        var clientId = this.getOption("clientId");

        if (clientId && fox.isNumeric(parseInt(clientId))) {
          this.wom1("#paymentDataConfirm").send({ clientId: clientId }, false);
        }
      },

      togglePaxumRegisterLink: function (state) {
        this._bindData.paxumRegisterLinkState =
          state === true ? "show" : "hide";
      },

      renderButton: function (payMethod) {
        console.log("render");
        let template = this.sc.needAuth()
          ? "edit_payment_data_button"
          : "save_payment_data_button";
        if (payMethod == 0) template = "save_payment_data_button";
        this.paymentDataButton.setOption("template", template).render();
      },
      updateFields: function (el) {
        var paymethod = +this.pm.getValue();

        this.legalType =
          paymethod == 4
            ? this.legalTypePaxumSelect.value
            : this.legalTypeSelect.value;
        this.toggleBindText(paymethod, this.legalType);
        this._validateField("legalType");

        if ([1, 2, 4, 5, 6].includes(paymethod)) {
          var fields = this.getFormFields(
            paymethod,
            this.rwom1("#paymentForm").getValue("country"),
            this.legalType
          );
          var methodOrderMap = mapOrder[paymethod];
          fox.each(
            this.dom("[data-row]"),
            function (node) {
              node.style.display =
                fields.indexOf(node.getAttribute("data-row")) === -1
                  ? "none"
                  : "block";
              if (methodOrderMap !== undefined) {
                node.style.order =
                  methodOrderMap[node.getAttribute("data-row")];
              } else {
                node.style.order = 0;
              }
            },
            this
          );
        }
      },
      changePaymentDescription: function (paymethod) {
        var elem = this.dom1("#payDesc");

        if (paymethod === 0) {
          elem.parentElement.classList.add("pay-desc-none");
        } else {
          elem.parentElement.classList.remove("pay-desc-none");
        }
        var payDesc;
        payMethodsDesc.forEach((i) => {
          if (i.value === paymethod) {
            payDesc = i;
          }
        });

        elem.innerText = _.getTranslation(payDesc.alias);
      },
      convertFileToBase64: function (elt) {
        var file = elt.files[0];
        this._bindData.ownershipDocument = file.name;
        var reader = new FileReader();
        if (!(file instanceof Blob)) {
          file = fox.utils.createBlob(file);
        }
        reader.readAsDataURL(file);

        reader.onload = () => {
          this._bindData.ownershipDocumentData = reader.result;
        };
        reader.onerror = function () {
          this._bindData.ownershipDocumentData = "";
          console.log("there are some problems");
        };
      },

      downloadFile: function (el) {
        const linkSource = el.getAttribute("base64_attr");
        const fileName = el.getAttribute("name_attr");
        const downloadLink = document.createElement("a");

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },
    },
    "Widget"
  );
})(fox, fox.jQuery);



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/account/paymentDetails.es.js